import { Listable } from 'data/types';
import Image from 'next/legacy/image';
import Link from 'next/link';

type Props = {
  pathPrefix: string;
  listables: Array<Listable>;
};

export default function ListableList({ pathPrefix, listables }: Props) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 not-prose">
      {listables.map((listable) => (
        <div
          key={listable.slug}
          className="relative flex items-center px-6 py-5 space-x-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500 h-24"
        >
          <div className="flex-1 min-w-0">
            <Link
              href={`${pathPrefix}/${listable.slug}`}
              className="focus:outline-none"
            >
              <span className="absolute inset-0" aria-hidden="true" />
              <p className="text-sm font-medium text-gray-900">
                {listable.name}
              </p>
              {/* <p className="text-sm text-gray-500 truncate">
              {manufacturer.regions}
            </p> */}
            </Link>
          </div>
          <div className="flex-shrink-0">
            {listable.webpPath && listable.imageWidth && listable.imageHeight && (
              <div className="w-20">
                <Image
                  src={listable.webpPath}
                  width={70 * (listable.imageWidth / listable.imageHeight)}
                  height={70}
                  alt={listable.name}
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

type GenericListProps = {
  listables: Array<string>;
};

export const GenericList = ({ listables }: GenericListProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 not-prose">
      {listables.map((listable) => (
        <div
          key={listable}
          className="relative flex items-center px-6 py-5 space-x-3 bg-white border border-gray-300 rounded-lg shadow-sm hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
        >
          <div className="flex-1 min-w-0">
            <span className="absolute inset-0" aria-hidden="true" />
            <p className="text-sm font-medium text-gray-900">{listable}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
